import type { AdminMyFatoorahTransactionItem } from '../types/adminMyfatoorahTransaction';

export type MyFatoorahTransactionKpis = {
  total: number;
  paid: number;
  pending: number;
  failed: number;
  cancelled: number;
};

export function computeMyFatoorahTransactionKpis(
  items: AdminMyFatoorahTransactionItem[],
): MyFatoorahTransactionKpis {
  const paid = items.filter((t) => t.status === 'paid').length;
  const pending = items.filter((t) => t.status === 'pending').length;
  const failed = items.filter((t) => t.status === 'failed').length;
  const cancelled = items.filter((t) => t.status === 'cancelled').length;
  return { total: items.length, paid, pending, failed, cancelled };
}
